import RequestService from '@/service'
import { IApiUser } from '@/apis/user/type.ts'

export default class ApiUser {
  // 获取用户信息
  static getUserInfo() {
    return RequestService.get({
      url: '/chain/user/get-data'
    })
  }

  static editUserInfo(data: IApiUser.TEditUserInfo) {
    return RequestService.put({
      url: '/chain/user/put-data',
      data
    })
  }

  // 修改用户密码 ---> id: 用户id,  mobile: 手机号，code：验证码, password: 密码
  static editUserPassword(data: IApiUser.TEditUserPassword) {
    return RequestService.put({
      url: '/chain/user/sms-revise',
      data
    })
  }

  // 修改用户密码 ---> id: 用户id,  mobile: 手机号，code：验证码, password: 密码
  static forgetPassword(data: IApiUser.TEditUserPassword) {
    return RequestService.put({
      url: '/chain/user/sms-forget',
      data
    })
  }
}
